import { render, staticRenderFns } from "./CrearLiquidacion.vue?vue&type=template&id=10556318"
import script from "./CrearLiquidacion.vue?vue&type=script&lang=js"
export * from "./CrearLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports